import React, { Component } from 'react'
import Radium from 'higher-order-components/configured-radium/'
import { VideoBackground, StepCounter, WysiwygContent, Button } from 'components'
import { HeadingBlock, ArrowIcon } from 'containers'
import ReactSlider from 'react-slick'
import { withRadium, DetectCompact } from 'higher-order-components'
import COLOR_PALETTE from 'constants/color-palette'
import { injectGlobal } from 'styled-components'
import globalStyles from './slick.css'

if (process.env.BABEL_ENV && process.env.BABEL_ENV === 'dingo') {
  injectGlobal`
    ${globalStyles}
  `
} else {
  require('./slick.css')
}

class VideoSlideshow extends Component {
  constructor() {
    super()
    this.videoElements = []
  }
  resetAndPlayAll = () => {
    this.videoElements.forEach((video) => {
      if (video) {
        video.currentTime = 0
        video.play()
      }
    })
  }

  next() {
    this._slider.slickNext()
  }

  render() {
    const {
      videos = [],
      heading,
      preHeading,
      content,
      annotation,
      buttonText = 'CHOOSE YOUR PLACE',
      autoAdvance = true
    } = this.props

    const settings = {
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      swipeToSlide: false,
      fade: true,
      useCSS: true,
      speed: 500,
      cssEase: 'linear',
      draggable: false,
      slidesToScroll: 1
    }
    return (
      <div style={styles.base(this.props.compact)} data-test="slideshow">
        <div style={styles.content(this.props.compact)}>
          <div style={{
            maxWidth: '60em',
            margin: '0 auto',
            textShadow: '0 0px 150px #000000'
          }}>
            <HeadingBlock
              preHeading={preHeading}
              value={heading}
              applyTopMargin={false}
              tag="h1"
              margin />
            {content && <WysiwygContent
              theme='dark'
              style={{ color: '#FFF' }}
              xmlString={content} />}
            {annotation && (
              <p>{annotation}</p>
            )}
          </div>
        </div>
        <div
          style={{
            position:'relative',
            zIndex: 1,
          }}
        >
          <ReactSlider
            swipe={false}
            ref={(element) => {
              this._slider = element
            }}
            {...settings}>
            {videos &&
              videos.map((video, index) => (
                <div key={index} style={styles.slideItem}>
                  {video && <VideoBackground
                    onEnded={() => {
                      if (index === 0) this.resetAndPlayAll()
                      autoAdvance && this.next()
                    }}
                    getVideoRef={(element) => { this.videoElements[index] = element }}
                    index={index}
                    poster={this.props.compact ? video.mobileBackgroundImage || video.backgroundImage : video.backgroundImage}
                    loop={false} // Dont loop videos. We will trigger play manually
                    src={this.props.compact ? '' : video.videoSrc} />}
                </div>
              ))}
          </ReactSlider>
        </div>
        {buttonText &&
          <div style={styles.buttom(this.props.compact)}>
            <div style={{
              maxWidth: '60em',
              margin: '0 auto',
              display: 'flex',
              justifyContent: 'center',
            }}>
              <Button
                onClick={() => {
                  this.next()
                }}
                styleName="white"
                label={buttonText} />
            </div>
          </div>
        }
      </div >
    )
  }
}

export default withRadium(DetectCompact())(VideoSlideshow)

const styles = {
  base: compact => ({
    color: '#FFF',
    textAlign: 'center',
    backgroundColor: compact ? COLOR_PALETTE.BLACK : 'none',
    position: 'relative',
    padding: compact ? '3em 0' : 'initial'
  }),
  content: compact => ({
    position: compact ? 'relative' : 'absolute',
    top: compact ? '0.5em' : '5em',
    zIndex: 2,
    width: '100%',
    padding: '0 2em',
    boxSizing: 'border-box'
  }),
  buttom: compact => ({
    position: compact ? 'relative' : 'absolute',
    bottom: compact ? '0' : '2em',
    width: '100%',
    zIndex: 2,
  }),
  slideItem: {
    minHeight: '50vw',
    zIndex: 11,
    position: 'relative'
  }
}



// WEBPACK FOOTER //
// ./src/components/video-slideshow/index.jsx